import React, { Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Link, withRouter } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import ErrorMessage from '../../components/errormessage';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import { enforceSlash } from '../../utils/helpers';
import { Table, Tr, Td, Th, Thead } from 'reactable';

@inject('superStore')
@observer
class MailHooksContainer extends React.Component {
    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        await this.props.superStore.loadSubjects();
    }

    render() {
        const { loadingSubjects, subjects, subjectsError } =
            this.props.superStore;
        const { match } = this.props;

        return loadingSubjects ? (
            <ThemedSpinner />
        ) : (
            <Fragment>
                <ErrorMessage error={subjectsError} />
                {console.log(subjects)}
                <Row>
                    {subjects && subjects.length > 0 && (
                        <Col md="12" xs="12" className="leftMenu">
                            <Table
                                className="table"
                                id="table"
                                itemsPerPage={500}
                                pageButtonLimit={5}
                            >
                                <Thead>
                                    <Th column="Name" className="">
                                        Name
                                    </Th>
                                    <Th column="Episode" className="">
                                        Episode
                                    </Th>
                                    <Th column="Id" className="">
                                        Id
                                    </Th>
                                    <Th column="Rules" className="">
                                        # of Rules
                                    </Th>
                                    <Th column="Languages" className="">
                                        Languages
                                    </Th>
                                    <Th column="public" className="">
                                        Public{' '}
                                    </Th>
                                </Thead>
                                {subjects.map((subj, i) => (
                                    <Tr key={`${i}-${subj.subject_id}`}>
                                        <Td column={'Name'} value={subj.name}>
                                            <Link
                                                to={`${enforceSlash(
                                                    match.url
                                                )}${subj.subject_id}`}
                                            >
                                                {subj.title}
                                            </Link>
                                        </Td>
                                        <Td
                                            column={'Episode'}
                                            value={subj.episode_number}
                                        >
                                            <Link
                                                to={`${enforceSlash(
                                                    match.url
                                                )}${subj.subject_id}`}
                                            >
                                                {subj.episode_number}
                                            </Link>
                                        </Td>
                                        <Td
                                            column={'Id'}
                                            value={subj.subject_id}
                                            className=""
                                        >
                                            <Link
                                                to={`${enforceSlash(
                                                    match.url
                                                )}${subj.subject_id}`}
                                            >
                                                {subj.subject_id}
                                            </Link>
                                        </Td>
                                        <Td
                                            column={'Rules'}
                                            value={subj.rulesCount}
                                        >
                                            {subj.rulesCount}
                                        </Td>

                                        <Td
                                            column={'Languages'}
                                            value={subj.languages}
                                        >
                                            <Fragment>
                                                {subj.languages
                                                    .splice(
                                                        0,
                                                        subj.languages.length -
                                                            1
                                                    )
                                                    .map((c) => (
                                                        <Fragment key={c}>
                                                            {c},{' '}
                                                        </Fragment>
                                                    ))}
                                            </Fragment>
                                        </Td>
                                        <Td column={'public'} value={subj.name}>
                                            <Fragment>
                                                {subj.isPublic > 0 ? (
                                                    <span
                                                        className={
                                                            'flag static-flag '
                                                        }
                                                        style={{
                                                            backgroundImage: `url(/static/img/icon-completed.png)`,
                                                        }}
                                                    >
                                                        &nbsp;
                                                    </span>
                                                ) : (
                                                    <span
                                                        className={
                                                            'flag static-flag '
                                                        }
                                                        style={{
                                                            backgroundImage: `url(/static/img/icon-close.png)`,
                                                        }}
                                                    >
                                                        &nbsp;
                                                    </span>
                                                )}
                                            </Fragment>
                                        </Td>
                                    </Tr>
                                ))}
                            </Table>
                        </Col>
                    )}
                </Row>
            </Fragment>
        );
    }
}

export default withRouter(MailHooksContainer);
